import ApiService from "@/_services/api/api.service";
import appConfig from "@/app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductionPlanningService = {

    async getProductionPlanningGrouped(StartDate, EndDate, Filter) {
        const requestScreenData = {
            url: "api/ProductionPlanning/Grouped",
        };

        if (StartDate && EndDate) {
            requestScreenData.url += `?StartDate=${StartDate}&EndDate=${EndDate}`;
        }

        if (Filter) {
            requestScreenData.url += `&$filter=${Filter}`;
        }

        return await ApiService.oDataGet(requestScreenData);
    },


    async getBomProducts(prodFilter) {
        const requestScreenData = {
            url: "api/BomProduct",
            filter: prodFilter || null,
            expand: "BomList($select=Code,BatchSize,Description1,BranchCode,DivisionCode)",
        };

        return await ApiService.oDataGet(requestScreenData);
    },

    async saveProductionPlanning(data) {
        return await ApiService.post("api/ProductionPlanning", data);
    },

    async checkProductionPlanningExists(StartDate, EndDate) {
        const requestScreenData = {
            url: `api/ProductionPlanning/Exists?StartDate=${StartDate}&EndDate=${EndDate}`,
        };

        return await ApiService.oDataGet(requestScreenData);
    },

    async saveCopyProductionPlanning(data) {
        return await ApiService.post("api/ProductionPlanning/Copy", data);
    }
}

export { ProductionPlanningService };